import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { STORES_NAMESPACE } from '~/external-ids';
import { SharedAppStateStore } from '~/shared-app-state/shared-app-state';
import { SlotContext } from '~/types/common-types';
import { resolveDefaultNamespace } from '~commons/resolve-default-namespace';
import { createControllerMulti } from './controller/multi/controller-multi';
import { createControllerSingle } from './controller/single/controller-single';
import { RATING_LIST_WIDGET_ID } from '~/app-ids';
import { createSettingsEventHandler } from '~commons/settings/create-settings-event-handler';
import { RatingsSummarySettingsEvent } from '~ratings/Settings/commons/settings-events';

const createController: CreateControllerFn = async (controllerParams) => {
  if (process.env.NODE_ENV === 'test') {
    // @ts-expect-error
    window.exposeControllerParams?.(controllerParams);
  }

  const { flowAPI } = controllerParams;
  const { wixCodeApi, config } = flowAPI.controllerConfig;
  flowAPI.errorMonitor?.addBreadcrumb({ data: { url: wixCodeApi.location.url } });
  const slotContext: SlotContext | undefined =
    flowAPI.controllerConfig.config.publicData.COMPONENT?.slotContext;

  const sharedAppStateStore: SharedAppStateStore | undefined =
    controllerParams.appData?.sharedAppStateStore;

  const defaultNamespace = resolveDefaultNamespace(
    slotContext,
    STORES_NAMESPACE,
    flowAPI.experiments.enabled('specs.wixReviews.useStoresAsDefaultNamespace')
      ? flowAPI.controllerConfig.type
      : '',
  );

  const settingsEventHandler = createSettingsEventHandler<RatingsSummarySettingsEvent>(
    config.publicData.COMPONENT,
  );

  if (controllerParams.controllerConfig.type === RATING_LIST_WIDGET_ID) {
    return createControllerMulti({
      controllerParams,
      defaultNamespace,
      sharedAppStateStore,
      settingsEventHandler,
    });
  }

  return createControllerSingle({
    controllerParams,
    defaultNamespace,
    sharedAppStateStore,
    settingsEventHandler,
  });
};

export default createController;
